module.exports = __webpack_public_path__ + "edd1e4e70077cebddb73609b1faaa6a3.svg";